import React from 'react';

import * as S from './PersuasionHoverText.styles';
import {IPersuasionText} from '../../../../../shared/pages/SRP/redux/types';
import RoundedCheckbox from '../../../../Icons/RoundedCheckbox';

import HermesIconSelector from '../../../../../shared/components/HermesIconSelector';

interface IPosition {
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  transform?: string;
}

// can be re-factored to allow more flexible renderItem inside, but requires splicing off
// internal styling and bloating to container level
// currently only 2 scenarios required to be served - List of text, Text block
// if more scenarios are to be pushed, should refactor to renderItem for ContentBlock inside
// something like renderContentBlock()
const PersuasionHoverText = ({
  data,
  actionHandler = () => {},
  direction = 'bottom',
  // hasPersuasionTitlePadding = false,
  defaultIcon = '',
  position,
  persuasionTitleStyles = {},
  wrapperStyles = '',
  type = '',
  hasMainTextIcon = false,
  gaHandler,
  TriggerTextComponent,
  showLabelTextBorder,
}: {
  data: Array<IPersuasionText>;
  direction?: string;
  actionHandler?: Function;
  gaHandler?: Function;
  // hasPersuasionTitlePadding?: boolean;
  defaultIcon?: string;
  position?: {
    wrapperDiv?: IPosition;
    tip?: IPosition;
  };
  persuasionTitleStyles?: {
    [k: string]: string; // css styles
  };
  wrapperStyles?: string;
  type?: string;
  hasMainTextIcon?: boolean;
  TriggerTextComponent?: React.FC<any>;
  showLabelTextBorder?: boolean;
}) => {
  const colorEmptyInstantiation = {bgc: '', tc: ''};

  const [hoverState, setHoverState] = React.useState(false);

  const handleTriggerTextHover = () => setHoverState(true);
  const handleTriggerTextMouseLeave = () => setHoverState(false);

  const hasSingleItem = data && data.length === 1;

  const isAboveRatePlanPersuasion = type === 'aboveRatePlanPersuasion';

  // const isContentPersuasion2 = type === 'contentPersuasion2';

  return (
    <S.WrapperDiv>
      {data.map((item, index) => {
        if (index > 1) return;

        const {
          ic: labelIconText,
          pt: persuasionTitle,
          ccd: colorCodeDesc = colorEmptyInstantiation,
          htd: hoverTextDescription = {},
          ui: uiType = '',
        } = item;

        const filterData = item?.fd;

        const {
          bgc: persuasionTitleBackgroundColor = '',
          tc: persuasionTitleTextColor = '',
          ig: isGradient = false,
        } = colorCodeDesc;

        const {
          ht: hoverTextArr = [],
          ft: hoverFilterText = '',
          hec: hoverTitleColor = colorEmptyInstantiation,
          h: hoverTextTitle = '',
          ic: iconText = '',
          hoc: hoverColor = colorEmptyInstantiation,
        } = hoverTextDescription;

        const {tc: hoverTitleTextColor = '', bgc: hoverTitleBackgroundColor = ''} = hoverTitleColor;

        const {tc: hoverTextColor = '', bgc: hoverBackgroundColor = ''} = hoverColor;

        const hasHover = item?.htd;

        const mainTextIconName =
          isAboveRatePlanPersuasion && index === 0 ? 'tVoyagerPer' : labelIconText || iconText;

        const isGpt = uiType && uiType === 'gpt';

        if (isGpt) return null;

        return (
          <>
            <S.HoverTargetWrapperDiv
              key={persuasionTitle + index}
              hasMultiple={!hasSingleItem}
              type={type}
              onMouseEnter={handleTriggerTextHover}
              onMouseLeave={handleTriggerTextMouseLeave}
              wrapperStyles={wrapperStyles}
            >
              {(hasMainTextIcon && mainTextIconName && index === 0 && (
                <S.MainTextIconWrapperSpan type={type}>
                  <HermesIconSelector
                    name={mainTextIconName}
                    styleProps={{height: '1.6rem', width: '1.6rem', fill: persuasionTitleTextColor}}
                  />
                </S.MainTextIconWrapperSpan>
              )) ||
                null}

              {TriggerTextComponent ? (
                <TriggerTextComponent persuasionData={item} />
              ) : (
                <S.TextWrapperSpan
                  {...persuasionTitleStyles}
                  showLabelTextBorder={showLabelTextBorder}
                  hasHover={hasHover}
                  // hasPersuasionTitlePadding={index === 0}
                  color={persuasionTitleTextColor}
                  bgColor={persuasionTitleBackgroundColor}
                  isGradient={isGradient}
                  type={type}
                  hasBgColor={
                    persuasionTitleBackgroundColor &&
                    !(['#ffffff', 'white'].indexOf(persuasionTitleBackgroundColor) > -1)
                  }
                  hasSingleItem={hasSingleItem}
                  onClick={type === 'customLocation' ? actionHandler : () => {}}
                >
                  {!!labelIconText && !hasMainTextIcon && (
                    <S.TextLabelIconContainer>
                      <HermesIconSelector
                        name={labelIconText}
                        styleProps={{
                          height: '1.6rem',
                          width: '1.6rem',
                          fill: persuasionTitleTextColor,
                        }}
                      />
                    </S.TextLabelIconContainer>
                  )}

                  <span>{persuasionTitle}</span>
                </S.TextWrapperSpan>
              )}

              {(hoverTextDescription &&
                Object.keys(hoverTextDescription).length > 0 &&
                hoverState && (
                  <S.HiddenDropdownWrapperDiv
                    top={position?.wrapperDiv?.top}
                    bottom={position?.wrapperDiv?.bottom}
                    left={position?.wrapperDiv?.left}
                    right={position?.wrapperDiv?.right}
                    direction={direction}
                    className="persuasion-hover"
                  >
                    {/* <ClientOnly> */}
                    <S.TopDiv>
                      <S.TextBlockDropDownWrapper
                        color={hoverTextColor}
                        bgColor={hoverBackgroundColor}
                      >
                        <S.TextBlockDDHeading
                          color={hoverTitleTextColor}
                          bgColor={hoverTitleBackgroundColor}
                        >
                          <S.TextBlockDDHeadingSpan
                            color={hoverTitleTextColor}
                            bgColor={hoverTitleBackgroundColor}
                            onClick={type === 'customLocation' ? actionHandler : () => {}}
                          >
                            {(mainTextIconName &&
                              !(
                                ['aboveRatePlanPersuasion', 'belowPricePersuasion'].indexOf(type) >
                                -1
                              ) && (
                                <S.MiniIconWrapperSpan>
                                  <HermesIconSelector
                                    name={mainTextIconName} //  || iconText || defaultIcon
                                    styleProps={{
                                      height: '1.2rem',
                                      width: '1.2rem',
                                      fill: persuasionTitleTextColor,
                                    }}
                                  />
                                </S.MiniIconWrapperSpan>
                              )) ||
                              null}
                            <S.PersuasionHoverTitleSpan type={type}>
                              {hoverTextTitle}
                            </S.PersuasionHoverTitleSpan>
                          </S.TextBlockDDHeadingSpan>
                        </S.TextBlockDDHeading>
                        {(hoverTextArr.length > 1 &&
                          hoverTextArr.map((item, index) => (
                            <S.IconWrapperDiv key={index + item}>
                              <S.RoundBoxWrap>
                                <RoundedCheckbox fill={persuasionTitleTextColor} />
                              </S.RoundBoxWrap>
                              <S.TextWrapper>{item}</S.TextWrapper>
                            </S.IconWrapperDiv>
                          ))) || (
                          <S.TextBlockDDFilterText>
                            {hoverTextArr.map(item => item)}
                          </S.TextBlockDDFilterText>
                        )}
                        {(hoverFilterText && (
                          <S.BlueLinkText
                            onClick={e => {
                              e.stopPropagation();
                              actionHandler(filterData, hoverTextTitle);
                              gaHandler(hoverFilterText, JSON.stringify(filterData));
                            }}
                          >
                            {hoverFilterText}
                          </S.BlueLinkText>
                        )) ||
                          null}
                      </S.TextBlockDropDownWrapper>
                      <S.TipPositioning
                        top={position?.tip?.top}
                        bottom={position?.tip?.bottom}
                        left={position?.tip?.left}
                        right={position?.tip?.right}
                        transform={position?.tip?.transform}
                        bgColor={hoverBackgroundColor}
                        direction={direction}
                      />
                    </S.TopDiv>
                  </S.HiddenDropdownWrapperDiv>
                )) ||
                null}
            </S.HoverTargetWrapperDiv>
          </>
        );
      })}
    </S.WrapperDiv>
  );
};

export default PersuasionHoverText;
